import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { StripeService, SubscriptionPlan } from '../services/stripe.service';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-subscription-required',
  standalone: true,
  imports: [CommonModule, CardModule, ButtonModule, ToastModule],
  providers: [MessageService],
  template: `
    <div class="subscription-required-container">
      <p-toast></p-toast>
      <p-card styleClass="p-card-shadow">
        <div class="content-wrapper">
          <i class="pi pi-lock lock-icon"></i>
          <h1>Subscription Required</h1>
          <p>
            You need an active subscription to access this feature. 
            Please subscribe to Scryber Pro to continue.
          </p>
          
          <div class="actions" *ngIf="plans.length > 0">
            <button pButton 
              label="Subscribe Now" 
              icon="pi pi-credit-card"
              class="p-button-primary p-button-lg"
              [loading]="loading"
              (click)="subscribe(plans[0].stripePriceId)">
            </button>
            <button pButton 
              label="Go Back" 
              icon="pi pi-arrow-left"
              class="p-button-secondary p-button-text p-button-lg"
              [disabled]="loading"
              (click)="goBack()">
            </button>
          </div>
        </div>
      </p-card>
    </div>
  `,
  styles: [`
    .subscription-required-container { height: 100vh; display: flex; align-items: center; justify-content: center; background-color: var(--surface-ground); padding: 1rem; }
    ::ng-deep .p-card { max-width: 500px; width: 100%; border-radius: 12px; }
    .content-wrapper { text-align: center; padding: 2rem 1rem; }
    .lock-icon { font-size: 3rem; color: var(--text-color-secondary); margin-bottom: 1rem; }
    h1 { margin-top: 0; color: var(--text-color); font-size: 1.75rem; margin-bottom: 1rem; }
    p { color: var(--text-color-secondary); line-height: 1.5; margin-bottom: 2rem; font-size: 1.1rem; }
    .actions { display: flex; flex-direction: column; gap: 1rem; }
  `]
})
export class SubscriptionRequiredComponent implements OnInit {
  loading = false;
  plans: SubscriptionPlan[] = [];

  constructor(
    private stripeService: StripeService,
    private router: Router,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.stripeService.getPlans().subscribe({
      next: (res) => this.plans = res,
      error: (err) => console.error(err)
    });
  }

  subscribe(priceId: string): void {
    this.loading = true;
    this.stripeService.createCheckoutSession(priceId).subscribe({
      next: (res) => { if (res.url) window.location.href = res.url; },
      error: (err) => {
        console.error('Error creating checkout session', err);
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to start checkout.' });
      }
    });
  }

  goBack(): void {
    this.router.navigate(['/']);
  }
}
